module.exports = __webpack_public_path__ + "static/Desktops_Dell_Precision_Timeline-d814dcdcc8885f7f1a3e0fc7ae2e6e71.pdf";